module.exports = __webpack_public_path__ + "static/media/prinny-pattern.0afb6810.png";